import { Stack, Switch, Typography, styled, Radio, FormControlLabel } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { ManageEntityParametersModel } from "@store/entities/details";
import { BeetweenAutomationEnum } from "@store/common/beetweenAutomation.enum";

import { Colors } from "@constants/colors.constant";

export const RadioBtn = styled(Radio)({
    width: "15px",
    height: "15px",
    alignSelf: "center",
    marginRight: "5px",
    "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)": {
        color: Colors.primary,
        width: "15px",
        height: "15px",
    },
    "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
        color: Colors.primary,
        width: "15px",
        height: "15px",
    },
});

interface AccessToBeetweenConfigComponentProps {
    isActivated?: boolean;
    updateParameters: Dispatch<SetStateAction<ManageEntityParametersModel>>;
    beetweenAutomation?: BeetweenAutomationEnum;
}

const AccessToBeetweenConfigComponent = (props: AccessToBeetweenConfigComponentProps) => {
    const { isActivated = false, updateParameters, beetweenAutomation } = props;

    const { t } = useTranslation();

    const handleChangeBeetweenAutomation = (value: BeetweenAutomationEnum) => {
        updateParameters((state) => ({ ...state, beetweenAutomation: value }));
    };

    return (
        <Stack position="relative" width="100%">
            <Stack flex={0.5} width="100%" p="25px" bgcolor={Colors.background} borderRadius="15px" spacing={2}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" width="calc(100% + 10px)">
                    <Typography fontSize={16} fontWeight="700">
                        {t("clients.details.parametersTab.accessToBeetween.accessToBeetween")}
                    </Typography>
                    <Switch
                        checked={isActivated}
                        onChange={(_, checked) =>
                            updateParameters((state) => ({ ...state, hasAccessToBeetween: checked }))
                        }
                    />
                </Stack>
                {isActivated && (
                    <Stack spacing={1}>
                        <FormControlLabel
                            value={BeetweenAutomationEnum.NO_AUTOMATION}
                            control={
                                <RadioBtn
                                    id="noAutomation"
                                    value={BeetweenAutomationEnum.NO_AUTOMATION}
                                    checked={beetweenAutomation === BeetweenAutomationEnum.NO_AUTOMATION}
                                    onChange={(_, checked) => handleChangeBeetweenAutomation(checked ? BeetweenAutomationEnum.NO_AUTOMATION : BeetweenAutomationEnum.AUTOMATION_ON_APPLICATION_CREATION)}
                                />
                            }
                            label={
                                <Typography fontSize={14} fontWeight="300">
                                    {t("clients.details.parametersTab.accessToBeetween.noAutomation")}
                                </Typography>
                            }
                        />
                        <FormControlLabel
                            value={BeetweenAutomationEnum.AUTOMATION_ON_APPLICATION_CREATION}
                            control={
                                <RadioBtn
                                    id="automationOnApplicationCreation"
                                    value={BeetweenAutomationEnum.AUTOMATION_ON_APPLICATION_CREATION}
                                    checked={beetweenAutomation === BeetweenAutomationEnum.AUTOMATION_ON_APPLICATION_CREATION}
                                    onChange={(_, checked) => handleChangeBeetweenAutomation(checked ? BeetweenAutomationEnum.AUTOMATION_ON_APPLICATION_CREATION : BeetweenAutomationEnum.AUTOMATION_ON_APPLICATION_AI_EVALUATION)}
                                />
                            }
                            label={
                                <Typography fontSize={14} fontWeight="300">
                                    {t("clients.details.parametersTab.accessToBeetween.automationOnApplicationCreation")}
                                </Typography>
                            }
                        />
                        <FormControlLabel
                            value={BeetweenAutomationEnum.AUTOMATION_ON_APPLICATION_AI_EVALUATION}
                            control={
                                <RadioBtn
                                    id="automationOnApplicationAiEvaluation"
                                    value={BeetweenAutomationEnum.AUTOMATION_ON_APPLICATION_AI_EVALUATION}
                                    checked={beetweenAutomation === BeetweenAutomationEnum.AUTOMATION_ON_APPLICATION_AI_EVALUATION}
                                    onChange={(_, checked) => handleChangeBeetweenAutomation(checked ? BeetweenAutomationEnum.AUTOMATION_ON_APPLICATION_AI_EVALUATION : BeetweenAutomationEnum.AUTOMATION_ON_APPLICATION_CREATION)}
                                />
                            }
                            label={
                                <Typography fontSize={14} fontWeight="300" whiteSpace="nowrap">
                                    {t("clients.details.parametersTab.accessToBeetween.automationOnApplicationAiEvaluation")}
                                </Typography>
                            }
                        />
                    </Stack>
                )}
            </Stack>
        </Stack>
    );
};

export default AccessToBeetweenConfigComponent;
